import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import css from './CalendarTable.css';
import Icon from 'SF/MaterialIcon';
import useStarfishAPI from 'hooks/useStarfishAPI';

const CalendarTable = ({
  selectedRows, 
  setSelectedRows, 
  lockedCalendars, 
  onLoadCalendars,
  setToastMessage,
  allRowsSelected,
  allCalendars,
}) => {
  const [response, callAPI] = useStarfishAPI({ initialData: [], isNewAPI: true });

  const onOptionSelected = (checked, id) => {
    if ( checked ) setSelectedRows(selectedRows.concat([id]));
    else setSelectedRows(selectedRows.filter(item => item !== id));
  };

  const onSelectAllClicked = checked => {
    if ( checked ) setSelectedRows(allCalendars.map(({id}) => id));
    else setSelectedRows([]);
  };

  const isRowSelected = id => selectedRows.includes(id);

  const isLocked = id => lockedCalendars.includes(id);

  const generateId = id => `calendar-${id}`;

  const onSuccess = useCallback(onLoadCalendars, []);

  useEffect(() => {
    callAPI(`../api/lockable-schedules`, {
      method: "GET",
      headers: {
        Pragma: "no-cache",
        "Cache-Control": "no-cache",
        Expires: "-1"
      }
    });
  }, []);

  useEffect(() => {
    if ( response.success ) onSuccess(response.data);
    else if ( response.error ) setToastMessage(response.error);
  }, [response, onSuccess, setToastMessage]);

  return (
    <table className={css['table']}>
      <thead>
        <tr>
          <th className={css['owners']}>
            <div>
            <input 
              id={generateId("select-all")} 
              type="checkbox"
              checked={allRowsSelected}
              onChange={e => onSelectAllClicked(e.target.checked)}
            />
            <label htmlFor={generateId("select-all")}>
              Calendar Owner
            </label>
            </div>
          </th>
          <th>Access</th>
        </tr>
      </thead>
      <tbody>
        {response.success && response.data.map(person => (
          <tr 
            key={person.id} 
            style={{
              backgroundColor: isRowSelected(person.id) ? "#D6EAF8" : null,
              boxShadow: isRowSelected(person.id) ? "inset 0 -0.5px 0 0 #1E70A6, inset 0 0.5px 0 0 #1E70A6" : null,
            }}>
            <td>
              <div>
                <input 
                  id={generateId(person.id)}
                  checked={isRowSelected(person.id)} 
                  type="checkbox"
                  onChange={e => onOptionSelected(e.target.checked, person.id)}
                />
                <label htmlFor={generateId(person.id)}>
                  {person.name}
                </label>
              </div>
            </td>
            <td>
              <Icon 
                aria-hidden={true} 
                icon={isLocked(person.id) ? "lock" : "lock_open"}   
              />
              <span data-testid={generateId(person.id)}>
                {isLocked(person.id) ? "Locked" : "Unlocked"}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

CalendarTable.propTypes = {
  selectedRows: PropTypes.array.isRequired,
  setSelectedRows: PropTypes.func.isRequired,
  lockedCalendars: PropTypes.array.isRequired,
  onLoadCalendars: PropTypes.func.isRequired,
  setToastMessage: PropTypes.func.isRequired,
  allRowsSelected: PropTypes.bool.isRequired,
  allCalendars: PropTypes.array.isRequired,
}

export default CalendarTable;
